import axios from 'axios'
import { BASE_URL } from './constants/scrapper.constant'

const apiWebScrapper = axios.create({
	baseURL: BASE_URL
})

export default apiWebScrapper
